import type { ChatRoom } from 'models';
import { useMemo } from 'react';
import { useUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependencies
import { useGetNodeUserAvatar } from 'features/users/hooks';
import { useGetChatroomName } from '../../hooks';

type P = Pick<ChatRoom, 'name' | 'participants' | 'users'>;

export const useChatUserInfo = ({
  name,
  participants,
  users,
}: P): { email?: string; name: string; src?: string; userId: string } => {
  const getAvatarUrl = useGetNodeUserAvatar();
  const getChatroomName = useGetChatroomName();
  const { nodeUserData: nodeViewer } = useUser();
  const userId = users.find((memberUserId) => memberUserId !== nodeViewer._id) ?? nodeViewer._id;

  return useMemo(
    () => ({
      email: participants[userId]?.email,
      name: getChatroomName({ name, participants, users }),
      src: getAvatarUrl({ userId }),
      userId,
    }),
    [getAvatarUrl, getChatroomName, name, participants, userId, users],
  );
};
